import { getAnimationFrame } from './polyfills';

// SETTINGS
const colors = [
  '#94ab44', // green
  '#a33b55', // red
  '#da9d26', // orange
  '#3160a1' // blue
];

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

const routesDict = {
  down: {
    opposite: 'up',
    lengthProp: 'top',
    widthProp: 'left'
  },
  up: {
    opposite: 'down',
    lengthProp: 'top',
    widthProp: 'left'
  },
  left: {
    opposite: 'right',
    lengthProp: 'left',
    widthProp: 'top'
  },
  right: {
    opposite: 'left',
    lengthProp: 'left',
    widthProp: 'top'
  }
};

/**
 *
 * @param  {Boolean} opts.directionForward - status of that point going forward on the route, or in opposite direction
 * @param  {Number} opts.size - radius of circle
 * @return {[type]}      [description]
 */
function buildDots(opts) {
  'use strict';
  const circles = [];
  /* const directionForward = typeof opts.directionForward !== 'undefined'
    ? opts.directionForward
    : true;*/
  const routes = opts.directionForward ? opts.routes : opts.backwardRoutes;
  let routeIndex = 0, passedRouteLength = 0, currentRoute = routes[routeIndex];

  const stepMargin = opts.margin || 0;

  for (let i = 0, j = 0; i < opts.amount; i++) {
    const step = currentRoute.direction === 'down' ||
      currentRoute.direction === 'right'
      ? opts.step
      : -opts.step;
    const movingDirection = currentRoute.direction;
    const directionStructure = routesDict[movingDirection];

    const lengthPosition = j * step +
      (currentRoute.direction === 'down' || currentRoute.direction === 'right'
        ? currentRoute[directionStructure.lengthProp]
        : currentRoute[directionStructure.lengthProp] +
            currentRoute.routeLength) +
      stepMargin +
      getRandomInt(-5, 5);

    passedRouteLength = Math.abs(j * step);

    const widthPosition = getRandomInt(
      currentRoute[directionStructure.widthProp] + opts.size + 1,
      currentRoute[directionStructure.widthProp] +
        currentRoute.routeWidth -
        opts.size -
        1
    );

    const item = {
      color: colors[Math.floor(Math.random() * (colors.length - 1 + 1))],
      size: opts.size,
      [directionStructure.lengthProp]: lengthPosition,
      [directionStructure.widthProp]: widthPosition,
      speed: opts.speed,
      routeIndex: routeIndex,
      routes: routes,
      direction: movingDirection
    };

    circles.push(item);

    if (
      passedRouteLength + opts.step > currentRoute.routeLength &&
      typeof routes[routeIndex + 1] !== 'undefined' &&
      !opts.oneRoute
    ) {
      j = 0;
      routeIndex++;
      passedRouteLength = 0;
      currentRoute = routes[routeIndex];
    } else {
      j++;
    }
  }

  return circles;
}

function updateDots(circles, canvas, opts) {
  circles = circles.filter(circle => !circle.remove);

  const firstCircle = circles[0];

  if (firstCircle) {
    const firstRoute = firstCircle.routes[0];

    let groupMargin, shouldUpdate = false;
    /*lengthProp = routesDict[firstCircle.direction].lengthProp*/

    if (firstCircle.direction === 'up') {
      shouldUpdate = firstCircle.top < firstRoute.top + firstRoute.routeLength;
    } else if (firstCircle.direction === 'down') {
      shouldUpdate = firstCircle.top > firstRoute.top;
    } else if (firstCircle.direction === 'left') {
      shouldUpdate = firstCircle.left <
        firstRoute.left + firstRoute.routeLength;
    } else if (firstCircle.direction === 'right') {
      shouldUpdate = firstCircle.left > firstRoute.left;
    }

    if (shouldUpdate) {
      groupMargin = firstCircle.direction === 'up' ||
        firstCircle.direction === 'left'
        ? opts.step * opts.amount
        : -opts.step * opts.amount;

      circles = [
        ...buildDots({
          ...opts,
          margin: groupMargin,
          oneRoute: true
        }),
        ...circles
      ];
    }
  }
  return circles;
}

function drawFrame(context, circles, opts) {
  'use strict';
  for (let i = 0; i < circles.length; i++) {
    const curCircle = circles[i];
    context.fillStyle = curCircle.color;
    context.beginPath();

    const curRoute = curCircle.routes[curCircle.routeIndex];
    const direction = curCircle.direction;
    const nextRouteExists = curCircle.routeIndex + 1 < opts.routes.length;

    if (direction === 'up') {
      curCircle.top -= curCircle.speed;

      if (
        curCircle.top - opts.size - 2 - (curCircle.left - curRoute.left) <
          curRoute.top && nextRouteExists
      ) {
        curCircle.routeIndex += 1;
        curCircle.direction = curCircle.routes[curCircle.routeIndex].direction;
      }

      if (!nextRouteExists && curCircle.top + opts.size < curRoute.top) {
        curCircle.remove = true;
      }
    } else if (direction === 'down') {
      curCircle.top += curCircle.speed;

      if (
        curCircle.top + opts.size + 2 + (curCircle.left - curRoute.left) >
          curRoute.top + curRoute.routeLength && nextRouteExists
      ) {
        curCircle.routeIndex += 1;
        curCircle.direction = curCircle.routes[curCircle.routeIndex].direction;
      }

      if (
        !nextRouteExists &&
        curCircle.top - opts.size > curRoute.top + curRoute.routeLength
      ) {
        curCircle.remove = true;
      }
    } else if (direction === 'left') {
      curCircle.left -= curCircle.speed;

      if (
        curCircle.left - opts.size - 2 - (curCircle.top - curRoute.top) <
          curRoute.left && nextRouteExists
      ) {
        curCircle.routeIndex += 1;
        curCircle.direction = curCircle.routes[curCircle.routeIndex].direction;
      }

      if (!nextRouteExists && curCircle.left + opts.size < curRoute.left) {
        curCircle.remove = true;
      }
    } else if (direction === 'right') {
      curCircle.left += curCircle.speed;

      if (
        curCircle.left + opts.size + 2 + (curCircle.top - curRoute.top) >
          curRoute.left + curRoute.routeLength && nextRouteExists
      ) {
        curCircle.routeIndex += 1;
        curCircle.direction = curCircle.routes[curCircle.routeIndex].direction;
      }

      if (
        !nextRouteExists &&
        curCircle.left - opts.size > curRoute.left + curRoute.routeLength
      ) {
        curCircle.remove = true;
      }
    }

    context.arc(
      curCircle.left,
      curCircle.top,
      curCircle.size,
      0,
      2 * Math.PI,
      false
    );

    context.closePath();
    context.fill();
    context.ellipse;
  }
}

const defaultOpts = {
  amount: 40, // amount of circles in one direction
  size: 4, // size of circle
  routes: [],
  step: 0,
  speed: 1, // amount of pixel step per frame (frame = 1000ms / 60 frames)
  twoWayDirection: false
};

export default function animateDots(canvas, opts = {}) {
  const context = canvas.getContext('2d');

  let enabledStatus = true;

  opts = {
    ...defaultOpts,
    ...opts,
    height: canvas.height,
    step: Math.round(opts.routes.reduce((sum, route) => {
      sum += route.routeLength;
      return sum;
    }, 0) / opts.amount),
    backwardRoutes: [...opts.routes].reverse().map(route => {
      return {
        ...route,
        direction: routesDict[route.direction].opposite
      };
    })
  };

  let forwardCircles, backwardCircles;

  forwardCircles = buildDots({
    ...opts,
    directionForward: true,
    startingPoint: 0
  });

  if (opts.twoWayDirection) {
    backwardCircles = buildDots({
      ...opts,
      directionForward: false,
      startingPoint: canvas.width
    });
  }

  const requestAnimFrame = getAnimationFrame();
  (function animate() {
    // clear the canvas
    context.clearRect(0, 0, canvas.width, canvas.height);

    // draw the next frame
    drawFrame(context, forwardCircles, opts);
    if (backwardCircles) {
      drawFrame(context, backwardCircles, opts);
    }

    // request a new frame
    requestAnimFrame(function() {
      if (enabledStatus) {
        animate();
      }

      forwardCircles = updateDots(forwardCircles, canvas, {
        ...opts,
        directionForward: true
      });

      if (backwardCircles) {
        backwardCircles = updateDots(backwardCircles, canvas, {
          ...opts,
          directionForward: false
        });
      }
    });
  })();

  return {
    stop: () => {
      enabledStatus = false;
    }
  };
}



// WEBPACK FOOTER //
// ../src/utils/animateDots.js